import { isInApp } from './runtimeContext';

// Paths that are already a sensible "bottom" of the back stack.
const BASE_PATHS = ['/', '/app', '/home', '/login', '/signup', '/onboarding', '/auth/callback'];
const SKIP_PREFIXES = ['/admin', '/affiliate'];

/**
 * When the app shell (Despia / installed PWA) is launched straight into a
 * link (e.g. a shared Daily Reflection), put /home underneath it so Back
 * returns home instead of exiting. Runs once, before React Router boots.
 */
export function anchorLaunchHistory() {
  try {
    if (!isInApp()) return;
    const { pathname, search, hash } = window.location;
    if (window.history.state?.idx != null) return; // not a fresh launch
    if (BASE_PATHS.includes(pathname) || SKIP_PREFIXES.some((p) => pathname.startsWith(p))) return;
    if (hash.includes('session_id=')) return;
    window.history.replaceState({ usr: null, key: 'launch', idx: 0 }, '', '/home');
    window.history.pushState({ usr: null, key: 'deeplink', idx: 1 }, '', pathname + search + hash);
  } catch { /* history API unavailable */ }
}
